import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { ExternalLink, UpdateExternalLinkDto } from 'types';

export const updateExternalLink = ({
  data,
  linkId,
}: {
  data: UpdateExternalLinkDto;
  linkId: number;
}): Promise<ExternalLink> => {
  return axios.put(`/api/external-links/${linkId}`, data);
};

type UseUpdateExternalLinkOptions = {
  config?: MutationConfig<typeof updateExternalLink>;
};

export const useUpdateExternalLink = ({
  config,
}: UseUpdateExternalLinkOptions = {}) => {
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(['externalLinks']);
    },
    ...config,
    mutationFn: updateExternalLink,
  });
};
